<template>
  <div class="app-container">
    <!-- <el-tabs v-model="tabName" type="card" @tab-click="handleClick">
      <el-tab-pane label="访问日志" name="view">
        <view-list ref="viewList" />
      </el-tab-pane>
      <el-tab-pane label="操作日志" name="action">
        <action-list ref="actionList" />
      </el-tab-pane>
    </el-tabs> -->
    <action-list ref="actionList" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import actionList from "@/components/sys/ulog/list";
import viewList from "@/components/sys/ulog/viewLog";

export default {
  name: "ulog",
  mixins: [curdMixins],
  components: {
    actionList,
    viewList,
  },
  data() {
    return {
      tabName: "action",
    };
  },
  methods: {
    reload() {
      this.$refs[this.tabName + "List"].getData();
    },
    handleClick() {
      this.reload();
    },
  },
};
</script>